/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CableTraySystemComponent } from './cable-tray-system.component';
export { CableTraySystemModule } from './cable-tray-system.module';